import React from 'react';
import PickupMobile from './PickupMobile';
import PickupDesktop from './PickupDesktop';

const Pickup = () => {
  return (
    <div>
      <div className={`hidden lg:flex flex-col`}>
        <PickupDesktop />
      </div>
      <div className={`flex lg:hidden`}>
        <PickupMobile />
      </div>
    </div>
  );
};

export default Pickup;
